import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../redux/hook";
import { userSignOut } from "../redux/actions";
import { isQrCode } from "../utils";
import { navigateWithQr } from '../utils/routing.utils'
import { useLocation } from "react-router-dom";

export const useUserDropdown = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { user } = useAppSelector((state) => state.userReducer);
  const { support } = useAppSelector((state) => state.shopReducer);
  const phoneNumber = support?.number;

  const [copiedOpen, setCopiedOpen] = useState(false);

  const userName = useMemo(
    () => `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim(),
    [user]
  );

  const email = user?.email ?? "";
  const PROFILE_ROUTE = "/account/profile";
  const ORDER_ROUTE = "/account/orders";
  const goToOrders = useCallback(
    (close?: () => void) => {
      navigateWithQr(navigate, location.pathname, isQrCode() ? "/" : ORDER_ROUTE);
      close?.();
    },
    [navigate]
  );

  const goToProfile = useCallback(
    (close: () => void) => {
      navigate(PROFILE_ROUTE);
      close();
    },
    [navigate]
  );

  const logout = useCallback(
    (close: () => void) => {
      close();
      navigateWithQr(navigate, location.pathname, "/");
      dispatch(userSignOut());
    },
    [dispatch]
  );
  const goToHome = useCallback(
    (close: () => void) => {
      close();
      navigateWithQr(navigate, location.pathname, "/");
    },
    [dispatch]
  );

  const handleSupport = useCallback(
    (close: () => void) => {
      if (!phoneNumber) return;
      window.open(`tel:${phoneNumber}`)
      close();
    },
    [phoneNumber]
  );

  const menuConfig = [
    {
      label: "Commander",
      path: "/",
      action: goToHome,
    },
    {
      label: "Mes commandes",
      icon: "HandPlatter",
      path: ORDER_ROUTE,
      action: goToOrders,
    },
    {
      label: "Mon compte",
      icon: "person",
      path: PROFILE_ROUTE,
      action: goToProfile,
    },
    {
      label: "Se déconnecter",
      icon: "LogOut",
      action: logout,
      color: "red",
    },
  ];
  return {
    userName,
    email,
    copiedOpen,
    setCopiedOpen,
    logout,
    goToHome,
    handleSupport,
    goToOrders,
    goToProfile,
    menuConfig,
  };
};
